//src/pages/admin/AdminProviders.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function AdminProviders() {
  const [providers, setProviders] = useState([]);
  const [form, setForm] = useState({ name: "", baseUrl: "", apiKey: "" });

  const load = async () => {
    const res = await api.get("/providers");
    setProviders(res.data || []);
  };

  useEffect(() => {
    load();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    await api.post("/providers", form);
    setForm({ name: "", baseUrl: "", apiKey: "" });
    load();
  };

  const toggle = async (id) => {
    await api.patch(`/providers/${id}/toggle`);
    load();
  };

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold">Providers</h1>

      <form onSubmit={submit} className="card-glass p-4 space-y-3 max-w-lg">
        <input className="input-glass" placeholder="Name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })} />

        <input className="input-glass" placeholder="API URL"
          value={form.baseUrl}
          onChange={(e) => setForm({ ...form, baseUrl: e.target.value })} />

        <input className="input-glass" placeholder="API Key"
          value={form.apiKey}
          onChange={(e) => setForm({ ...form, apiKey: e.target.value })} />

        <button className="btn-primary">Add Provider</button>
      </form>

      <div className="grid md:grid-cols-2 gap-4">
        {providers.map((p) => (
          <div key={p._id} className="card-glass p-4 space-y-2">
            <div className="font-semibold">{p.name}</div>
            <div className="text-xs text-gray-400">{p.baseUrl}</div>
            <div>Status: {p.isActive ? "Active" : "Disabled"}</div>

            <button
              onClick={() => toggle(p._id)}
              className="btn-ghost"
            >
              {p.isActive ? "Disable" : "Enable"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
